import { render, staticRenderFns } from "./DeliveryMenuOrphanView.vue?vue&type=template&id=71610b2f&scoped=true"
import script from "./DeliveryMenuOrphanView.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuOrphanView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuOrphanView.vue?vue&type=style&index=0&id=71610b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71610b2f",
  null
  
)

export default component.exports